import React from 'react';
import PropTypes from 'prop-types';
import { round4 } from 'utilities/math';

class CoefficientSummaryTableRowComponent extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,

    estimate: PropTypes.number.isRequired,
    stderr: PropTypes.number.isRequired,

    tScore: PropTypes.number.isRequired,
    pValue: PropTypes.number.isRequired
  }

  render () {
    return (
      <tr>
        <td className="text-right" id={`name-${this.props.index}`}>
          {this.props.name}
        </td>

        <td className="text-right" id={`estimate-${this.props.index}`}>
          {round4(this.props.estimate)}
        </td>

        <td className="text-right" id={`stderr-${this.props.index}`}>
          {round4(this.props.stderr)}
        </td>

        <td className="text-right" id={`t-score-${this.props.index}`}>
          {round4(this.props.tScore)}
        </td>

        <td className="text-right" id={`p-value-${this.props.index}`}>
          {this.props.pValue.toExponential(3)}
        </td>
      </tr>
    );
  }
}

export default CoefficientSummaryTableRowComponent;
